export function minLengthFieldValidation(value?: string, minLength?: number) {
  if (value && minLength) {
    if (value.length >= minLength) {
      return true;
    }
  }

  return false;
}
